import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import InviteAcceptPage from './InviteAcceptPage';

export default function InviteAcceptTestPage() {
  const [params] = useSearchParams();
  const logo = params.get('logo');
  const email = params.get('email') || 'new.employee@example.com';
  const company = params.get('company') || 'Acme Wellness';
  const role = params.get('role') || 'employee';

  const mockInvite = useMemo(() => ({
    email,
    companyName: company,
    companyLogoUrl: logo || '',
    role,
  }), [email, company, logo, role]);

  return <InviteAcceptPage mockInvite={mockInvite} />;
}


